var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c("span", { attrs: { slot: "header" }, slot: "header" }, [
        _c("div", [_vm._v("Edit User Details")]),
        _c("div", { class: _vm.$style.subHeader }, [
          _vm._v(
            "Please fill out the form below, we will send the link to your user."
          ),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody hotel-directory",
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _c(
            "div",
            { class: _vm.$style.group },
            [
              _c(
                "rb-input",
                {
                  class: {
                    [_vm.$style.groupItem]: true,
                    rbInputEmpty: !_vm.data.user.firstName,
                  },
                  attrs: {
                    "for-id": "firstName",
                    error: _vm.$showError("firstName"),
                  },
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("First Name"),
                    _c("i", [_vm._v("*")]),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.data.user.firstName,
                        expression: "data.user.firstName",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|max:100",
                        expression: "'required|max:100'",
                      },
                    ],
                    staticClass: "rbInput",
                    attrs: {
                      id: "firstName",
                      type: "text",
                      name: "firstName",
                      autofocus: "",
                      maxlength: "100",
                      "data-vv-as": "First Name",
                    },
                    domProps: { value: _vm.data.user.firstName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.data.user,
                          "firstName",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]
              ),
              _c(
                "rb-input",
                {
                  class: {
                    [_vm.$style.groupItem]: true,
                    rbInputEmpty: !_vm.data.user.lastName,
                  },
                  attrs: {
                    "for-id": "lastName",
                    error: _vm.$showError("lastName"),
                  },
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("Last Name"),
                    _c("i", [_vm._v("*")]),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.data.user.lastName,
                        expression: "data.user.lastName",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|max:100",
                        expression: "'required|max:100'",
                      },
                    ],
                    staticClass: "rbInput",
                    attrs: {
                      id: "lastName",
                      type: "text",
                      name: "lastName",
                      maxlength: "100",
                      "data-vv-as": "Last name",
                    },
                    domProps: { value: _vm.data.user.lastName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.data.user, "lastName", $event.target.value)
                      },
                    },
                  }),
                ]
              ),
            ],
            1
          ),
          _c(
            "rb-input",
            {
              class: { rbInputEmpty: !_vm.data.user.email },
              attrs: { "for-id": "email", error: _vm.$showError("email") },
            },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("Email Address"),
                _c("i", [_vm._v("*")]),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.user.email,
                    expression: "data.user.email",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|email",
                    expression: "'required|email'",
                  },
                ],
                staticClass: "rbInput",
                attrs: {
                  id: "email",
                  type: "text",
                  name: "email",
                  "data-vv-as": "Email Adress",
                },
                domProps: { value: _vm.data.user.email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.data.user, "email", $event.target.value)
                  },
                },
              }),
            ]
          ),
          _c(
            "div",
            { class: _vm.$style.group },
            [
              _c(
                "rb-input",
                {
                  class: {
                    [_vm.$style.groupItem]: true,
                    rbInputEmpty: !_vm.data.user.phone,
                  },
                  attrs: { "for-id": "phone", error: _vm.$showError("phone") },
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("Phone Number"),
                    _c("i", [_vm._v("*")]),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.data.user.phone,
                        expression: "data.user.phone",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "max:100",
                        expression: "'max:100'",
                      },
                    ],
                    staticClass: "rbInput",
                    attrs: {
                      id: "phone",
                      type: "text",
                      name: "phone",
                      autofocus: "",
                      maxlength: "100",
                      "data-vv-as": "Phone number",
                    },
                    domProps: { value: _vm.data.user.phone },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.data.user, "phone", $event.target.value)
                      },
                    },
                  }),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { class: _vm.$style.group },
            [
              _c(
                "rb-input",
                {
                  class: {
                    [_vm.$style.groupItem]: true,
                    rbInputEmpty: !_vm.data.user.jobTitle,
                  },
                  attrs: {
                    "for-id": "jobTitle",
                    error: _vm.$showError("jobTitle"),
                  },
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("Job Title"),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.data.user.jobTitle,
                        expression: "data.user.jobTitle",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "max:100",
                        expression: "'max:100'",
                      },
                    ],
                    staticClass: "rbInput",
                    attrs: {
                      id: "jobTitle",
                      type: "text",
                      name: "jobTitle",
                      autofocus: "",
                      maxlength: "100",
                      "data-vv-as": "Job Title",
                    },
                    domProps: { value: _vm.data.user.jobTitle },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.data.user, "jobTitle", $event.target.value)
                      },
                    },
                  }),
                ]
              ),
              _c(
                "rb-input",
                {
                  class: {
                    [_vm.$style.groupItem]: true,
                    rbInputEmpty: !_vm.data.user.department,
                  },
                  attrs: {
                    "for-id": "department",
                    error: _vm.$showError("department"),
                  },
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("Deparment"),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.data.user.department,
                        expression: "data.user.department",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "max:100",
                        expression: "'max:100'",
                      },
                    ],
                    staticClass: "rbInput",
                    attrs: {
                      id: "department",
                      type: "text",
                      name: "department",
                      maxlength: "100",
                      "data-vv-as": "Department",
                    },
                    domProps: { value: _vm.data.user.department },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.data.user,
                          "department",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "button",
            {
              staticClass: "rbButton",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" Cancel ")]
          ),
          _c("button", { staticClass: "rbButton mainButton" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("save")]),
            _vm._v(" Apply Changes "),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }